<script>
export default {
    name: 'getEmptyText',   
}
export function getEmptyText(qtyResults) {
    if (qtyResults == 0){
        return "Geen resultaten gevonden";
    } 
    else {
        return "";
    }
}
</script>
